import { createContext } from 'react';
import { useFiltersContext } from '../../../../Common/Filters/hooks/useFiltersContext';
import {
    QUERY_KEYS_UR,
    useChartsData
} from '../../../../Common/hooks/useChartsData';

export const HouseholdRelationshipChartsDataContext = createContext();

const HouseholdRelationshipChartsDataProvider = ({ children }) => {
    const { filters } = useFiltersContext();
    const { data, isLoading, isError } = useChartsData(
        {
            key: QUERY_KEYS_UR.HOUSEHOLD_RELATIONSHIP_PEOPLE,
            url: 'governanceroom/dashboard/unifiedregistry/people/household-relationship'
        },
        {
            location: filters.unidade.value,
            city: filters.cidade?.value,
        }
    );

    const chartData = data
        ? {
              knowAboutFather: data?.knowAboutFather ?? [],
              knowAboutMother: data?.knowAboutMother ?? [],
              registeredPersonFamilyResponsableRelation:
                  data?.registeredPersonFamilyResponsableRelation ?? []
          }
        : {
              knowAboutFather: [],
              knowAboutMother: [],
              registeredPersonFamilyResponsableRelation: [],
          };

    return (
        <HouseholdRelationshipChartsDataContext.Provider
            value={{
                chartData,
                isLoading,
                isError,
                filters,
                data
            }}
        >
            {children}
        </HouseholdRelationshipChartsDataContext.Provider>
    );
};

export default HouseholdRelationshipChartsDataProvider;
